import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MainNavComponent from './FsMobileNav.styles.js';
import {
  FsMobileNavComponentFs
} from './FsMobileNav.styles.js';
import { SearchButton } from '../../MainNav.styles';
import Icon from '../../../shared/Icon/Icon.jsx';
import Link from '../../../shared/Link/Link';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import Hamburger from '../FsHamburger/FsHamburger.jsx';
import NavLink from '../../../NavLink/NavLink.jsx';
import Overlay from '../../../shared/Overlay/Overlay.jsx';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Button from "../../../shared/Button/Button.jsx";

const FsMobileNav = ({ headerContext = {}, sitecoreContext: { globalContent, route }, search, setSearch, className, ...props }) => {


  if (headerContext) {
    if (Array.isArray(headerContext.globalContent)) {
      globalContent = [...globalContent, ...headerContext.globalContent];
    } else if (typeof headerContext.globalContent === 'object' && headerContext.globalContent !== null) {
      globalContent = {...globalContent, ...headerContext.globalContent};
    } else {
      const globalContent = [headerContext.globalContent];
    }
  }


  const links = globalContent?.navigation;
  const utilityLinks = globalContent?.utilityLinks;
  const logo = globalContent?.logo;
  const homePageLink = globalContent?.homepageLink;
  const languageSelector = globalContent?.languageSelectorItems;
  const [FsMobileNav, setFsMobileNav] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [activeLink, setActiveLink] = useState('');


  const handleLanguageSelector = (newLangCode) => {
    if (!newLangCode) return;

    if (!isServer()) {
      let splitPath = window.location.pathname.split('/');
      splitPath[1] = newLangCode;
      return (window.location.href = splitPath.join('/'));
    }
  };

  return (
    <>
      <MainNavComponent className={`NAV_WRAP mobile-nav-${className}`} search={search}>
        <Hamburger
            className={`hamburger ${FsMobileNav ? 'active' : ''}`}
            active={FsMobileNav}
            onClick={() => {
              setFsMobileNav((prevState) => !prevState);
            }}
        />
        <div className="logo">
          <Link href={homePageLink}>
            <img src={`${logo?.src}?mw=650`} alt={logo?.alt} />
          </Link>
        </div>
        <div className="nav-end" id="nav-bar-search-button">
          <>
            <SearchButton
                id="search-button"
                className="search-button"
                title={search ? 'Close Search' : 'Open Search'}
                disabled={route?.name === 'search'}
                aria-label={search ? 'Close Search' : 'Open Search'}
                onClick={() => {
                  setSearch((prevState) => !prevState);
                }}
            >
              <Icon className="search" icon={search ? 'cross' : 'search'} size="lg"/>
            </SearchButton>
          </>
        </div>


        <FsMobileNavComponentFs active={FsMobileNav} className={`mobile-content-${className}`}>
          <ul>
            {Array.isArray(utilityLinks) &&
                utilityLinks.map(({title, path, href}, index) => {
                  return (
                      <li key={`${index}-${title}`}>
                      <NavLink
                          className="nav-end-link"
                          role="menuitem"
                          text={title}
                          path={path}
                          href={href}
                      />
                      </li>
                  );
                })}
            {Array.isArray(links) &&
                links.map(({path, title, type, cards}, index) => {
                  if (type && type === 'megamenu-cards') {
                    if (cards && cards.length > 0) {
                      return (
                          <li key={`${index}-${title}`}>
                            <NavLink
                                text={title}
                                subNav
                                mobile
                                className={activeLink === title ? 'active' : ''}
                                active={activeLink === title ? 'true' : 'false'}
                                onClick={(event) => {
                                  event.preventDefault();
                                  if (activeLink === title) {
                                    setActiveIndex(null);
                                    setActiveLink('');
                                  } else {
                                    setActiveIndex(index);
                                    setActiveLink(title);
                                  }
                                }}
                            />
                            <ul className={`subMenuList ${activeIndex === index ? 'active' : ''}`}>
                              {Array.isArray(cards) &&
                                  cards.map(({title, link}, index) => {
                                    let fullpath = `${link.path}${link.text ? link.text : ''}`;
                                    return (
                                        <li key={`${index}-${title}`}>
                                          <NavLink
                                              text={title}
                                              path={fullpath}
                                              query={link?.text}
                                              href={fullpath}
                                          />
                                        </li>
                                    );
                                  })}
                            </ul>
                          </li>
                      );
                    }
                    return (
                        <li key={`${index}-${title}`}>
                          <NavLink mobile text={title} path={path}/>
                        </li>
                    );
                  }
                  return (
                      <li key={`${index}-${title}`}>
                        <NavLink mobile text={title} path={path}/>
                      </li>
                  );
                })}
            {/*{Array.isArray(languageSelector) && languageSelector.length*/}
            {/*    ? languageSelector.map(({text, code}, index) => {*/}
            {/*      return (*/}
            {/*          <li key={`languageSelector-${index}-${text}`}>*/}
            {/*            <NavLink mobile text={text} onClick={() => handleLanguageSelector(code)}/>*/}
            {/*          </li>*/}
            {/*      );*/}
            {/*    })*/}
            {/*    : null}*/}
          </ul>
          <Button className="mobile-nav-button" size="small" text="Contact a Rep" href="/contact" variant={"yellowBlue"}/>
        </FsMobileNavComponentFs>
      </MainNavComponent>
      {FsMobileNav && <Overlay id="overlay" onClick={() => setFsMobileNav(false)}/>}
    </>
  );
};

FsMobileNav.propTypes = {
  headerContext: PropTypes.object,
  sitecoreContext: PropTypes.object,
  search: PropTypes.bool,
  setSearch: PropTypes.func,
  className: PropTypes.string,
};

export default withSitecoreContext()(FsMobileNav);